import { render, staticRenderFns } from "./ItemCardPost.vue?vue&type=template&id=7d46cf2c&scoped=true&"
import script from "./ItemCardPost.vue?vue&type=script&lang=js&"
export * from "./ItemCardPost.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardPost.vue?vue&type=style&index=0&id=7d46cf2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d46cf2c",
  null
  
)

export default component.exports